import { PendingItem } from 'interfaces';

/**
 * Collapse combo components into ONE display line per combo instance.
 *
 * Components of the same combo bowl share a persisted setMenuGroupId
 * (set by the order dialog for manual combos and by the external-order
 * injector for Bolt/Wolt ones), so two different combos in the same
 * order never merge. Used by BOTH the packing and lids screens so they
 * always show combos identically.
 *
 * The collapsed line keeps every component's menuItemId in
 * comboMenuItemIds — screens that record per-item actions (lids) must
 * fire for all of them, not just the first.
 */
export const collapseCombos = (items: PendingItem[]): PendingItem[] => {
  const groups = new Map<number, PendingItem[]>();
  const singles: PendingItem[] = [];

  items.forEach((it) => {
    const gid = it.setMenuGroupId;
    if (gid !== null && gid !== undefined) {
      const bucket = groups.get(gid) || [];
      bucket.push(it);
      groups.set(gid, bucket);
    } else {
      singles.push(it);
    }
  });

  const comboLines: PendingItem[] = Array.from(groups.values()).map(
    (components) => {
      const first = components[0];
      const contents = components.map((c) => c.menuItem).join(' + ');
      const extraNotes = Array.from(
        new Set(
          components.map((c) => (c.notes || '').trim()).filter((n) => n.length > 0),
        ),
      ).join(' | ');
      return {
        ...first,
        menuItem: `${first.setMenuName || 'Combo'} (Combo)`,
        notes: `COMBO — ${contents}${extraNotes ? ` | ${extraNotes}` : ''}`,
        quantity: 1,
        comboMenuItemIds: components.map((c) => c.menuItemId),
      };
    },
  );

  return [...comboLines, ...singles];
};
